import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartFundraiserWidgetComponent } from './components/start-fundraiser-widget/start-fundraiser-widget.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { InputModule } from '../../common/input/input.module';
import { ButtonModule } from '../../common/button/button.module';
import { IntlInputModule } from '../../common/intl-input/intl-input.module';
import { CaptchaModule } from '../../common/captcha/captcha.module';
import { AutoselectModule } from '../../common/autoselect/autoselect.module';
import { SelectModule } from '../../common/select/select.module';
import { PlaceAutocompleteModule } from '../../common/place-autocomplete/place-autocomplete.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

// import {
//   HeaderModule
// } from '../../common';
const AppCommonModules = [
  InputModule,
  ButtonModule,
  IntlInputModule,
  CaptchaModule,
  SelectModule,
  AutoselectModule,
  PlaceAutocompleteModule,
  // HeaderModule
];
@NgModule({
  declarations: [StartFundraiserWidgetComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatButtonModule,
    ...AppCommonModules
  ],
  exports: [
    StartFundraiserWidgetComponent
  ]
})
export class StartFundraiserWidgetModule { }
